module.exports = {
	"description": "MenuDividers separate [MenuItems](../menu-item) and [MenuGroups](../menu-group) to establish hierarchy in a [Menu](../menu) with several options.\n\nMenuDividers are not merely design elements to visually separate options.\nRather, the are a way to logically group choices.\nToo many dividers will add unnecessary weight to your Menu.",
	"methods": []
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-docgen-loader!./src/Menu/MenuDivider.js
// module id = 1679
// module chunks = 0